const COPILOT_PROMPT = {
  scene_code: 'QCworkbench',
  scene_name: '质控工作台',
  scene_type: 'CopilotWarm',
};
export const COPILOT_PROMPT_TRACKS = {
  viewClick: {
    ...COPILOT_PROMPT,
    event_name: '查看copilot提示内容',
    event_code: 'QCworkbench_CopilotWarm_click',
    event_type: 'click',
  },
  promptExpose: {
    ...COPILOT_PROMPT,
    event_name: '弹出copilot提示',
    event_code: 'QCworkbench_CopilotWarm_expose',
    event_type: 'expose',
  },
};

const COPILOT_GPT_SCENE = {
  scene_code: 'CopilotWorkbench',
  scene_name: '副驾工作页',
};
export const COPILOT_GPT_TRACKS = {
  tranCopy: {
    ...COPILOT_GPT_SCENE,
    scene_type: 'CopyTran',
    event_name: '复制GPT翻译结果',
    event_code: 'CopilotWorkbench_CopyTran_click',
    event_type: 'click',
  },
  polishCopy: {
    ...COPILOT_GPT_SCENE,
    scene_type: 'CopyPR',
    event_name: '复制GPT润色结果',
    event_code: 'CopilotWorkbench_CopyPR_click',
    event_type: 'click',
  },
};
